import { PlayerProperty, Restore, Save } from "../PlayerProperty";
import IPlayerData from "../../IPlayerData";
import { IPlayerState } from "State/Player/IPlayerState";
import { restoreStringifiedArray, restoreStringifiedObject } from "../../ParseHelper";
import { FarmAreaId } from "State/Player/Farm/IFarmPlayerState";
import { initialFarmPlayerState } from "State/Player/Farm/initialFarmPlayerState";
import { FarmItemId } from "System/Farm/Data/FarmItemData";

const slotsKey = 'v2_9_0_farm_slots' as const;
const unlockedFarmAreasKey = 'v2_9_0_unlocked_farm_areas' as const;

type PlayerStateKey = 'farmState';
type PlayerDataKeys =
    | typeof slotsKey
    | typeof unlockedFarmAreasKey;

export default class Farm implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        const newEndpointData = this.save(playerStateData);
        return (
            newEndpointData[slotsKey] !== playerEndpointData[slotsKey] ||
            newEndpointData[unlockedFarmAreasKey] !== playerEndpointData[unlockedFarmAreasKey]
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return {
            slots: restoreStringifiedObject(playerEndpointData[slotsKey], initialFarmPlayerState.slots),
            unlockedAreas: restoreStringifiedArray<FarmAreaId>(playerEndpointData[unlockedFarmAreasKey], initialFarmPlayerState.unlockedAreas)
        };
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            [slotsKey]: JSON.stringify(playerStateData.farmState.slots),
            [unlockedFarmAreasKey]: JSON.stringify(playerStateData.farmState.unlockedAreas)
        };
    }
}
